/* eslint-disable react/no-danger */
import React from "react";
import PropTypes from "prop-types";

import clsx from "clsx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import SocialIcons from "components/SocialIcons";

const ContentHeader = ({
  header = "CONTENT HEADER",
  subtitle = "",
  social = false,
  line = false,
  hr = false,
  children = null,
  icon = null,
  layout = "column",
}) => {
  const iconValues = Array.isArray(icon) ? icon : ["fas", icon];

  // Allows for different layouts. Currently only affects the positioning of the icont vs the header text. Defaults to column (original layout).
  const horizontalLayouts = ["row"];
  const verticalLayouts = ["column"];

  const headerClasses = clsx("header-box__container", {
    "header-box__container--row": horizontalLayouts.includes(layout),
    "header-box__container--column": verticalLayouts.includes(layout),
  });

  return (
    <div className="contentHeader" id="contentHeader">
      <div className={headerClasses}>
        {icon && <FontAwesomeIcon icon={iconValues} className="icon" />}
        <h3>{header}</h3>
      </div>
      <h6 dangerouslySetInnerHTML={{ __html: subtitle }} />
      {hr && <hr />}
      {line && <div className="line" />}
      {children}
      {social && <SocialIcons />}
    </div>
  );
};

export default ContentHeader;

ContentHeader.propTypes = {
  header: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
  social: PropTypes.bool,
  line: PropTypes.bool,
  hr: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  layout: PropTypes.oneOf(["", "row", "column"]),
};

// ContentHeader.defaultProps = {
//   header: 'CONTENT HEADER',
//   subtitle: '',
//   children: null,
//   social: false,
//   line: false,
// };
